import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Loader, Dimmer } from 'semantic-ui-react';
import _, { isEmpty } from 'lodash';
import localStore from 'store';
import client from '../apollo';

import EnrollmentStatusList from '../views/EnrollmentStatus/List';
import enrollmentHistoryQuery from '../graphql/enrollmentHistoryQuery';

const EnrollmentStatus = props => {
  const { handlePendingAcceptanceLink } = props;

  const [loading, setLoading] = useState(false);
  const [offersInitiatedSince, setOffersInitiatedSince] = useState(0);
  const [singleDealerQuotes, setSingleDealerQuotes] = useState(true);
  const [myQuotes, setMyQuotes] = useState(true);
  const [groupQuotes, setGroupQuotes] = useState(false);
  const [allStaffs, setAllStaffs] = useState(false);
  const [enrollments, setEnrollments] = useState([]);
  const [column, setColumn] = useState('sendAtWithTime');
  const [direction, setDirection] = useState('descending');

  const fetchEnrollmentHistory = useCallback((
    initiatedSince,
    singleQuotes,
    grpQuotes,
    myQts,
    allStf
  ) => {
    setLoading(true);

    client
      .query({
        query: enrollmentHistoryQuery,
        variables: {
          offersInitiatedSince: initiatedSince,
          singleDealerQuotes: singleQuotes,
          groupQuotes: grpQuotes,
          myQuotes: myQts,
          allStaffs: allStf,
        },
        fetchPolicy: 'network-only',
      })
      .then(({ data }) => {
        const { enrollmentHistory: { enrollments: historyEnrollments } } = data;
        setEnrollments(historyEnrollments);
        setLoading(false);
        setColumn('sendAtWithTime');
        setDirection('descending');
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const enrollmentStatusFilter = localStore.get('enrollmentStatusFilter');

    if (!isEmpty(enrollmentStatusFilter)) {
      const {
        offersInitiatedSince: initSince,
        singleDealerQuotes: singleQuotes,
        myQuotes: myQts,
        groupQuotes: grpQuotes,
        allStaffs: allStf,
      } = enrollmentStatusFilter;

      setOffersInitiatedSince(initSince);
      setSingleDealerQuotes(singleQuotes);
      setMyQuotes(myQts);
      setGroupQuotes(grpQuotes);
      setAllStaffs(allStf);

      fetchEnrollmentHistory(initSince, singleQuotes, grpQuotes, myQts, allStf);
    } else {
      fetchEnrollmentHistory(0, true, false, true, false);
    }
  }, [fetchEnrollmentHistory]);

  const handleSort = useCallback(clickedColumn => () => {
    if (column !== clickedColumn) {
      setColumn(clickedColumn);
      setEnrollments(_.sortBy(enrollments, [clickedColumn]));
      setDirection('ascending');
      return;
    }

    const en = Object.assign([], enrollments);
    const dir = direction === 'ascending' ? 'descending' : 'ascending';
    setEnrollments(en.reverse());
    setDirection(dir);
    localStore.set('enrollmentStatusSorting', {
      column: clickedColumn,
      direction: dir,
    });
  }, [column, enrollments, direction]);

  const submitFilter = useCallback(() => {
    localStore.set('enrollmentStatusFilter', {
      offersInitiatedSince,
      singleDealerQuotes,
      myQuotes,
      groupQuotes,
      allStaffs,
    });
    fetchEnrollmentHistory(
      offersInitiatedSince,
      singleDealerQuotes,
      groupQuotes,
      myQuotes,
      allStaffs
    );
  }, [
    offersInitiatedSince,
    singleDealerQuotes,
    myQuotes,
    groupQuotes,
    allStaffs,
    fetchEnrollmentHistory,
  ]);

  const onCheckboxHandler = useCallback((field, value) => {
    if (field === 'singleDealerQuotes') setSingleDealerQuotes(value);
    if (field === 'myQuotes') setMyQuotes(value);
    if (field === 'groupQuotes') setGroupQuotes(value);
    if (field === 'allStaffs') setAllStaffs(value);
  }, []);

  const onSelectHandler = useCallback((field, value) => {
    if (field === 'offersInitiatedSince') setOffersInitiatedSince(value);
  }, []);

  return (
    <div className='dealer-enrollment'>
      {' '}
      {loading && (
        <Dimmer active inverted>
          <Loader size='large'> Loading </Loader>{' '}
        </Dimmer>
      )}{' '}
      <EnrollmentStatusList
        enrollments={enrollments}
        handleSort={handleSort}
        onSelectHandler={onSelectHandler}
        submitFilter={submitFilter}
        onCheckboxHandler={onCheckboxHandler}
        handlePendingAcceptanceLink={handlePendingAcceptanceLink}
        offersInitiatedSince={offersInitiatedSince}
        singleDealerQuotes={singleDealerQuotes}
        myQuotes={myQuotes}
        groupQuotes={groupQuotes}
        allStaffs={allStaffs}
        column={column}
        direction={direction}
      />{' '}
    </div>
  );
};

EnrollmentStatus.propTypes = {
  handlePendingAcceptanceLink: PropTypes.func.isRequired,
};

export default EnrollmentStatus;
